import StateDefaultTypeTextArea, { StateDefaultTypeTextAreaProps } from './StateDefaultTypeTextArea';

export type { StateDefaultTypeTextAreaProps };
export default StateDefaultTypeTextArea;
